import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SelectButtonContent({
  count,
  messageName,
  messageNameWithCount
}) {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: count === 0 ? messageName : messageNameWithCount,
    options: {
      count
    }
  });
}